import styled from "styled-components";

/**
 * Vertical line seperator with gaps on each side.
 * Used for seperating horizontally HTML objects.
 */
export const Vl = styled.div<{
  color?: string;
  spacing?: "2" | "5" | "10" | string;
  height?: "0.25" | "0.5" | "0.75" | "1";
}>`
  height: ${({ height }) => (height ? `${Number(height) * 100}%` : "50%")};
  width: 2px;
  background-color: ${({ color }) => color ?? "var(--light-gray)"};
  margin: ${({ spacing }) => (spacing ? `0px ${spacing}` : "0px 10px")};
`;
